"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _formInputTheme = require("./formInputTheme");
const StyledInput = (0, _styled.default)("input")`
    font-family: inherit;
    font-size: ${_ref => {
  let {
    themeMode,
    variant
  } = _ref;
  return _formInputTheme.formInputTheme.fontSize[variant](themeMode);
}};
    line-height: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _formInputTheme.formInputTheme.lineHeight(themeMode);
}}px;
    font-weight: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _formInputTheme.formInputTheme.fontWeight(themeMode);
}};

    box-sizing: border-box;
    margin: 0;
    padding: 0px ${getPaddingRight} 0px ${getPaddingLeft};
    width: 100%;
    outline: none;

    color: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return `var(--sds--form--color--value, ${_formInputTheme.formInputTheme.textColor.rest(themeMode)})`;
}};
    background-color: transparent;

    &::placeholder {
        color: ${_ref5 => {
  let {
    themeMode,
    isHovered
  } = _ref5;
  return isHovered ? _formInputTheme.formInputTheme.placeholderColor.hover(themeMode) : `var(--sds--form--color--placeholder, ${_formInputTheme.formInputTheme.placeholderColor.rest(themeMode)})`;
}};
    }
    &[aria-disabled="true"] {
        color: ${_ref6 => {
  let {
    themeMode
  } = _ref6;
  return _formInputTheme.formInputTheme.textColor.readonly(themeMode);
}};
        cursor: not-allowed;
        &::placeholder {
            color: ${_ref7 => {
  let {
    themeMode
  } = _ref7;
  return `var(--sds--form--color--placeholder, ${_formInputTheme.formInputTheme.placeholderColor.rest(themeMode)})`;
}};
        }
    }

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    border-style: none;
    // Use the outer component's radius.
    border-radius: inherit;
`;

// The following functions are necessary because the padding of the input is dependent on the
// presence of content before/after. In Ursa, with content before/after the padding is 8px. Without, it's 12px (really 11px due to the border).
exports.StyledInput = StyledInput;
function getPaddingLeft(_ref8) {
  let {
    themeMode,
    hasContentBefore,
    validationState,
    isFocused,
    focusMode,
    variant
  } = _ref8;
  if (!hasContentBefore && variant !== "underline") {
    return `${_formInputTheme.formInputTheme.padding.default[(0, _formInputTheme.getStylingState)({
      validationState,
      isFocused,
      focusMode
    })](themeMode)}px`;
  } else if (variant === "underline") {
    return `${_formInputTheme.formInputTheme.padding.default.rest(themeMode)}px`;
  } else {
    return `${_formInputTheme.formInputTheme.padding.betweenContent(themeMode)}px`;
  }
}
function getPaddingRight(_ref9) {
  let {
    themeMode,
    hasContentAfter,
    validationState,
    isFocused,
    focusMode,
    variant
  } = _ref9;
  if (!hasContentAfter && variant !== "underline") {
    return `${_formInputTheme.formInputTheme.padding.default[(0, _formInputTheme.getStylingState)({
      validationState,
      isFocused,
      focusMode
    })](themeMode)}px`;
  } else if (variant === "underline") {
    return `${_formInputTheme.formInputTheme.padding.default.rest(themeMode)}px`;
  } else {
    return `${_formInputTheme.formInputTheme.padding.betweenContent(themeMode)}px`;
  }
}
//# sourceMappingURL=StyledInput.js.map